export default __webpack_public_path__ + "static/media/kokoro.dc6e800c.png";